export default __webpack_public_path__ + "static/6-thompson-label-cb89df9d64ffb6c79a9ffd2e614d7557.svg";